export enum ApplicationIds {
    CasualPortal = 12,
}
